// internationalsApiDisplay.ts - Combined API for internationals page and individual brands
import { baseURL } from './baseUrl';

// Shared types
export interface CarouselItem {
  id: string;
  img_name?: string;
  img_url?: string;
  video_name?: string;
  video_url?: string;
  type: 'image' | 'video';
}

export interface CatalogueItem {
  id: string;
  title: string;
  issuu_link: string;
  catalogue_tile_img?: string;
  catalogue_tile_img_url?: string;
}

export interface FeaturedMedia {
  id: string;
  position: 'top left' | 'bottom left' | 'bottom right';
  img_name?: string;
  img_url?: string;
}

// Types for main internationals page
export interface InternationalBrandPage {
  id: number;
  is_published: boolean;
  position_order: number;
  page_title: string;
  page_description: string;
  brand_page_link?: string | null; // ✅ ADDED - URL link for the brand
  tile_img?: string;
  tile_img_url?: string;
}

export interface InternationalSettings {
  id?: number;
  is_published: boolean;
  page_title: string;
  page_description: string;
  catalogue_section_heading: string;
  catalogue_section_items: CatalogueItem[];
  consumer_banner_video?: string;
  consumer_banner_video_url?: string;
  consumer_banner_carousel: CarouselItem[];
  consumer_banner_media_switch: 'video' | 'carousel';
  consumer_banner_link: string;
  consumer_banner_width: number;
  consumer_banner_height: number;
  trade_banner_video?: string;
  trade_banner_video_url?: string;
  trade_banner_carousel: CarouselItem[];
  trade_banner_media_switch: 'video' | 'carousel';
  trade_banner_link: string;
  trade_banner_width: number;
  trade_banner_height: number;
  brands: InternationalBrandPage[];
}

export interface InternationalDisplayResponse {
  success: boolean;
  code: number;
  msg: string;
  settings: InternationalSettings;
}

// Types for individual brand pages
export interface BrandPageData {
  id: number;
  is_published: boolean;
  position_order: number;
  page_title: string;
  page_description: string;
  brand_page_link?: string | null; // ✅ ADDED - URL link for the brand
  tile_img?: string;
  tile_img_url?: string;
  catalogue_section_heading_first: string;
  catalogue_section_sub_heading_first: string;
  catalogue_section_items_first: CatalogueItem[];
  catalogue_section_heading_second: string;
  catalogue_section_sub_heading_second: string;
  catalogue_section_items_second: CatalogueItem[];
  promo_video: string;
  promo_video_loop: boolean;
  promo_video_hide_controls: boolean;
  consumer_banner_video?: string;
  consumer_banner_video_url?: string;
  consumer_banner_carousel: CarouselItem[];
  consumer_banner_media_switch: 'video' | 'carousel';
  consumer_banner_link: string;
  consumer_banner_width: number;
  consumer_banner_height: number;
  trade_banner_video?: string;
  trade_banner_video_url?: string;
  trade_banner_carousel: CarouselItem[];
  trade_banner_media_switch: 'video' | 'carousel';
  trade_banner_link: string;
  trade_banner_width: number;
  trade_banner_height: number;
  featured_collection_title: string;
  featured_collection_description: string;
  featured_collection_media: FeaturedMedia[];
  featured_collection_link: string;
}

export interface BrandDisplayResponse {
  success: boolean;
  code: number;
  msg: string;
  brand_page: BrandPageData;
}

// API Functions

// Get main internationals page data (existing)
export const apiGetInternationalsDisplay = async (): Promise<InternationalDisplayResponse> => {
  const response = await baseURL.get('/internationals-page/settings', {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

// Get individual brand page data (new)
export const apiGetBrandDisplay = async (brandId: string): Promise<BrandDisplayResponse> => {
  const response = await baseURL.get(`/internationals-page/brand-page/${brandId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};